module.exports = __webpack_public_path__ + "static/og-930946123e1cd52c4fe95e93b022be90.jpg";